import { render } from "./Legend_Appeals.vue?vue&type=template&id=76272c4e"
import script from "./Legend_Appeals.vue?vue&type=script&lang=js"
export * from "./Legend_Appeals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__